const EyeIcon: React.FC = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3084_590)">
        <rect width="16" height="16" transform="translate(0 0.5)" fill="white" fillOpacity="0.01" />
        <g clipPath="url(#clip1_3084_590)">
          <path
            d="M15.9997 8.49916C15.9997 8.49916 12.9997 2.99916 7.99974 2.99916C2.99974 2.99916 -0.000255942 8.49916 -0.000255942 8.49916C-0.000255942 8.49916 2.99974 13.9992 7.99974 13.9992C12.9997 13.9992 15.9997 8.49916 15.9997 8.49916ZM1.17274 8.49916C1.65626 7.76429 2.21238 7.07985 2.83274 6.45616C4.11974 5.16716 5.87974 3.99916 7.99974 3.99916C10.1197 3.99916 11.8787 5.16716 13.1677 6.45616C13.7881 7.07985 14.3442 7.76429 14.8277 8.49916C14.7697 8.58616 14.7057 8.68216 14.6327 8.78716C14.2977 9.26716 13.8027 9.90716 13.1677 10.5422C11.8787 11.8312 10.1187 12.9992 7.99974 12.9992C5.87974 12.9992 4.12074 11.8312 2.83174 10.5422C2.21139 9.91847 1.65626 9.23404 1.17274 8.49916Z"
            fill="#6E6E6E"
          />
          <path
            d="M7.99974 5.99916C7.3367 5.99916 6.70082 6.26256 6.23198 6.7314C5.76314 7.20024 5.49974 7.83612 5.49974 8.49916C5.49974 9.16221 5.76314 9.79809 6.23198 10.2669C6.70082 10.7358 7.3367 10.9992 7.99974 10.9992C8.66279 10.9992 9.29867 10.7358 9.76751 10.2669C10.2364 9.79809 10.4997 9.16221 10.4997 8.49916C10.4997 7.83612 10.2364 7.20024 9.76751 6.7314C9.29867 6.26256 8.66279 5.99916 7.99974 5.99916ZM4.49974 8.49916C4.49974 7.57091 4.86849 6.68067 5.52487 6.02429C6.18125 5.36791 7.07149 4.99916 7.99974 4.99916C8.928 4.99916 9.81824 5.36791 10.4746 6.02429C11.131 6.68067 11.4997 7.57091 11.4997 8.49916C11.4997 9.42742 11.131 10.3177 10.4746 10.974C9.81824 11.6304 8.928 11.9992 7.99974 11.9992C7.07149 11.9992 6.18125 11.6304 5.52487 10.974C4.86849 10.3177 4.49974 9.42742 4.49974 8.49916Z"
            fill="#6E6E6E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3084_590">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
        <clipPath id="clip1_3084_590">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeIcon;
